/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
const InserterListboxContext = createContext();
export default InserterListboxContext;
//# sourceMappingURL=context.js.map